export default __webpack_public_path__ + "static/jrahs-7086a0b32015da38c9dc14b26d97085a.jpg";